import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import usePermission from 'src/hooks/usePermissions';
import useWindowSize from 'src/hooks/useWindowSize';
import { PunchoutRedirectProvider } from 'src/sections/punchout_order_guide/PunchoutRedirectContext';
import CreateSupplierSidePanelContainer from 'src/sections/manage_suppliers/CreateSupplierSidePanelContainer';
import EditSupplierSidePanelContainer from 'src/sections/manage_suppliers/EditSupplierSidePanelContainer';
import { SuppliersContextProvider } from 'src/sections/manage_suppliers/SuppliersContext';
import SuppliersHeader from 'src/sections/manage_suppliers/SuppliersHeader';
import SuppliersTable from 'src/sections/manage_suppliers/SuppliersTable';
import { SupplierInfoEditPermissions } from 'src/sections/manage_suppliers/utils/supplierInfoPermissions';
import 'src/style/grid/grid-override.scss';
import 'src/style/manage-suppliers/Suppliers.scss';

const ManageSuppliers = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();
  const canEditSupplierInfo = usePermission({
    permissions: SupplierInfoEditPermissions,
    or: true,
  });

  return (
    <ErrorBoundary>
      <SuppliersContextProvider>
        <PunchoutRedirectProvider
          errorMessage={t('An Error occurred, Please contact your system administrator.')}
        >
          <div className="manage-suppliers-layout" style={{ height: `${height}px` }}>
          <div className="mb-2 min-h-0 bg-white" style={{ gridArea: 'navbar' }}>
            <Navbar
              title={
                canEditSupplierInfo
                  ? t('Create PO / View and Edit Suppliers')
                  : t('Create PO / View Suppliers')
              }
            />
            <SuppliersHeader />
          </div>
          <div
            className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-white"
            style={{ gridArea: 'main' }}
          >
            <SuppliersTable />
          </div>
          <CreateSupplierSidePanelContainer />
          <EditSupplierSidePanelContainer />
        </div>
        </PunchoutRedirectProvider>
      </SuppliersContextProvider>
    </ErrorBoundary>
  );
};

export default ManageSuppliers;
